import {ENCODING_TARGET} from '@constants/resources';
import Form from '@appComponents/ReduxFormControls';
import { BASE_FORM_MESSAGES, SAVED, NOT_SAVED } from '@constants/messages';

import validate from '../validatorThirdPartyTunnelerPush';
import {GetThirdPartyClientTunnelerOptions} from '../../../../graphql/clientProductThirdParty/query.graphql';
import {AddThirdPartyClientTunnel} from '../../../../graphql/thirdPartyClients/mutation.graphql';


export default function ThirdPartyTunnelerPushModel() {
    return {
        formName: 'Third Party Tunneler Push form',
        formClassName: 'thirdPartyTunnelerPushForm',
        title: () => ('Add new third party client tunnel'),
        resources: ENCODING_TARGET,
        validate: validate,
        messages: {
            boxName: {
                success: 'event',
                error: 'event',
            },
            text: {
                ...BASE_FORM_MESSAGES,
                SAVED: () => SAVED('third party client tunnel configuration'),
                NOT_SAVED: () => NOT_SAVED('third party client tunnel configuration'),
            },
        },
        query: {
            getOptions: GetThirdPartyClientTunnelerOptions,
        },
        mutation: {
            createEntity: AddThirdPartyClientTunnel,
        },
        mutationOptions: {
            create: {
                refetchQueries: [
                    'GetEventContentEncodingConfigurationChanged',
                    'GetThirdPartyClientTunnelsForEventContent',
                    'GetEncodingTargetsForDistributions',
                ],
            },
        },
        fields: {
            client: {
                optionsKey: 'client',
                props: {
                    component: Form.SemanticSelect,
                    label: 'Client',
                    name: 'client',
                    required: true,
                },
            },
            tunnel: {
                optionsKey: 'tunnel',
                props: {
                    component: Form.SemanticSelect,
                    label: 'Tunnel',
                    name: 'tunnel',
                    required: true,
                    hidden: true,
                },
            },
        },
    };
}
